// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---themes-gatsby-theme-marketing-src-pages-404-js": () => import("./../../../../../themes/gatsby-theme-marketing/src/pages/404.js" /* webpackChunkName: "component---themes-gatsby-theme-marketing-src-pages-404-js" */),
  "component---themes-gatsby-theme-marketing-src-templates-page-query-tsx": () => import("./../../../../../themes/gatsby-theme-marketing/src/templates/page-query.tsx" /* webpackChunkName: "component---themes-gatsby-theme-marketing-src-templates-page-query-tsx" */)
}

